var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningIcon = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FFE06772-09E6-4B7D-BAD2-E915E1D1BD0E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REIS-add-Transaction",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REIS_Add-Transaction-(Acquisition)-v2.0-Update-Popup",
    transform: "translate(-392.000000, -359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(359.000000, 267.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Success/Filled/30",
    transform: "translate(33.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,30 C6.71572875,30 3.55271368e-15,23.2842712 3.55271368e-15,15 C3.55271368e-15,6.71572875 6.71572875,1.0658141e-14 15,1.0658141e-14 C23.2842712,1.0658141e-14 30,6.71572875 30,15 C30,23.2842712 23.2842712,30 15,30 Z",
    id: "Combined-Shape",
    fill: "#FBB04C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8,6.6 L16.8,6.6 L16.5509025,17.4 L14.0490975,17.4 L13.8,6.6 Z M15,23.4 C13.9048193,23.4 13.2,22.6890282 13.2,21.6056426 C13.2,20.5109718 13.9048193,19.8 15,19.8 C16.0951807,19.8 16.8,20.5109718 16.8,21.6056426 C16.8,22.6890282 16.0951807,23.4 15,23.4 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WarningIcon.64ec6c982ae4695067d5343a16aac9bc.svg";